import { useMutation } from '@tanstack/react-query';
import { UpdateOrganizationDocumentVerificationDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

type UpdateResponse = {
    documentVerificationEnabled: boolean;
    documentVerificationMembershipTypeId: string | null;
    documentVerificationCustomPrompt: string | null;
};

export const useUpdateOrganizationDocumentVerification = (
    organizationId: string,
    onSuccess: () => void,
) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationDocumentVerification', organizationId],
        mutationFn: (body: UpdateOrganizationDocumentVerificationDto) =>
            apiClient.fetchApi<UpdateResponse, UpdateOrganizationDocumentVerificationDto>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/document-verification`,
                body,
            }),
        onSuccess: (data) => {
            onSuccess();
            if (selectedOrganization && organizationId === selectedOrganization.id) {
                setSelectedOrganization({
                    ...selectedOrganization,
                    documentVerificationEnabled: data.documentVerificationEnabled,
                    documentVerificationMembershipTypeId: data.documentVerificationMembershipTypeId,
                    documentVerificationCustomPrompt: data.documentVerificationCustomPrompt,
                });
            }
        },
    });
};
